import Vue from "vue";
import formatToURL from "../util/formatToURL";

class ShoppingCartItem {
  /**
   * @param {number} id
   * @param {string} img
   * @param {string} title
   * @param {number} price
   * @param {string} observations
   * @param {number} quant
   * @param {object} variant
   */
  constructor(id, img, title, price, observations, quant, variant) {
    this.state = Vue.observable({
      id,
      img,
      title,
      price,
      observations,
      quant,
      variant,
    });
  }

  get id() {
    return this.state.id;
  }

  get img() {
    return this.state.img;
  }

  get title() {
    return this.state.title;
  }

  get price() {
    return this.state.price;
  }

  get observations() {
    return this.state.observations;
  }

  get quant() {
    return this.state.quant;
  }

  get variant() {
    return this.state.variant;
  }

  get to() {
    return `/p/${formatToURL(this.title)}-${this.id}`;
  }

  increment() {
    this.state.quant++;
  }

  decrement() {
    if (this.state.quant <= 1) return;

    this.state.quant--;
  }
}

export default ShoppingCartItem;
